import { render, staticRenderFns } from "./Count.vue?vue&type=template&id=c3b2e66c&scoped=true&"
import script from "./Count.vue?vue&type=script&lang=js&"
export * from "./Count.vue?vue&type=script&lang=js&"
import style0 from "./Count.vue?vue&type=style&index=0&id=c3b2e66c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b2e66c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VCard,VCardText,VIcon,VSkeletonLoader})
